import { environment } from './../../../../environments/environment.prod';
import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';

import { AppConfig } from '../../../config';

import { PolaznikUcionicaService } from './polaznik-ucionica.service';
import { UcionicaService } from '../ucionica-detalji/ucionica-detalji.service';

import { FormGroup, FormBuilder } from '@angular/forms';

import * as toastr from 'toastr';
import { Moduli } from '../ucionica-detalji/ucionica-detalji';
declare var moment: any;

declare var $:any;
@Component({
  selector: 'app-polaznik-ucionica',
  templateUrl: './polaznik-ucionica.component.html',
  providers: [PolaznikUcionicaService, UcionicaService]
})
export class PolaznikUcionicaComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('iFrame',{}) iframe: ElementRef;

  Url: any;
  naziv: string;
  ucionica_datumOd: any;
  ucionica_datumDo: any;
  grad: string;
  trajanje: string;
  vrstaedukacije: any;
  videoNaslov: string;

  sviVideozapisiPopis: any[];
  sviDokumenti: any[];
  sviPredavaci: any = [];
  sviIshodiucenja: any = [];
  sviModuli: any = [];
  savRaspored: any = [];
  svaPrisutnost: any = [];
  tabNaziv: string = 'prikaziVideozapise';
  ucionicaId: any;
  sviKriterijiUcionica: any;
  ishodiUcenja: any = [];
  imaIshoda: boolean = false;

  URL: any = AppConfig.IPfile;
  accessToken: any = localStorage.getItem('tokenSql');

  datum: any = new Date();
  prikaziVideo: boolean = false;
  trenutniVideo: any;

  rasporedEditForma: FormGroup;
  nastavnajedinicaEditForma: FormGroup;

  myDatePickerOptions = {
		todayBtnTxt: 'Danas',
		dateFormat: 'dd.mm.yyyy',
		firstDayOfWeek: 'mo',
		sunHighlight: true,
		height: '34px',
		width: '100%',
		inline: false,
		selectionTxtFontSize: '16px',
		dayLabels: {su: 'Ned', mo: 'Pon', tu: 'Uto', we: 'Sri', th: 'Čet', fr: 'Pet', sa: 'Sub'},
		monthLabels: { 1: 'Sij', 2: 'Velj', 3: 'Ožu', 4: 'Tra', 5: 'Svi', 6: 'Lip', 7: 'Srp', 8: 'Kol', 9: 'Ruj', 10: 'Lis', 11: 'Stu', 12: 'Pro' }
  };
  
  datumPrikaz: any;

  prisutnost: number;
  prisutnostDA: number;
  prisutnostUkupno: any;
  prisutnostPrikaz: boolean;

  ishodiNastavneJediniceTrigger: Subject<Moduli> = new Subject();

  constructor(
    private _activated: ActivatedRoute,
    private _domSanitizer:DomSanitizer,
    private _fb: FormBuilder,
    private _polaznikUcionicaService: PolaznikUcionicaService,
    public _router: Router,
    private _ucionicaService: UcionicaService
  ) {}

  ngOnInit() {
    if(this._activated.snapshot.params['id']){
      this.detalji(this._activated.snapshot.params['id']);
      this.ucionicaId = this._activated.snapshot.params['id'];
      // this.videoZapisiPopis();
      // this.dokumentiPopis();
    } else {
      toastr.error("ID učionice nepoznat!");
    }

    this.rasporedEditForma = this._fb.group({
      naziv: [''],
      datum: [''],
      brojdanaranije: [''],
      brojdanaizmeduedukacije: ['']
    });

    this.nastavnajedinicaEditForma = this._fb.group({
      iducionicamodul: [''],
      naziv: {value:'', disabled: true},
      datum: [''],
      dogovorisastanak: [''],
      datumivrijeme: [''],
    });
  }

  // stopVideo(e){
  //    this.iframe.nativeElement.contentWindow.location.replace(this.Url);
  // }

  stopVideo(){
    this.iframe.nativeElement.contentWindow.location.replace(this.Url);
    this.prikaziVideo = false;
    this.trenutniVideo = 0;
  }

  detalji(ucionicaId){
    this._ucionicaService.detaljiUcionice({'iducionica':ucionicaId}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        //for(let i = 0; i < res.data.length; i++){
          this.naziv = res.data[0].uc_naziv;
          this.ucionica_datumOd = res.data[0].datumOD;
          this.ucionica_datumDo = res.data[0].datumDO; 
          this.grad = res.data[0].uc_grad;
          this.trajanje = res.data[0].uc_trajanjeEdukacije;
          /* u polje uc_grad bude upisano Individualno ako je vrsa edukacije individualno */
          this.vrstaedukacije = res.data[0].uc_grad;
        //}
      } else {
         toastr.error("Neuspješno dohvaćanje!");
      }
    })
  }

  videoZapisiPopis(){
    let podaciZaSlanje = {
      'idkorisnik': localStorage.getItem('userId'),
      'iducionica': this.ucionicaId,
      'datum': moment(this.datum).format('YYYY-MM-DD')
    }
    //console.log(podaciZaSlanje);
    this._polaznikUcionicaService.videoZapisi(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        this.sviVideozapisiPopis = [];
        if(res.data.length > 0){
          for(let i = 0; i < res.data.length; i++){
            this.sviVideozapisiPopis.push({
              'id': res.data[i]['idvideomaterijal'],
              'rednibroj': res.data[i]['um_redoslijedizvodenja'],
              'naziv': res.data[i]['vz_videonaziv'],
              'link': res.data[i]['link'],
              'trenutno_gledanja': res.data[i]['bg_brojgledanja'] || 0,
              'max_gledanja': res.data[i]['vz_maxbrojpregleda'],
              'datum_od': moment(res.data[i]['vz_dostupnostOd']).format('DD.MM.YYYY.'),
              'datum_do': moment(res.data[i]['vz_dostupnostDo']).format('DD.MM.YYYY.'),
              'statuspregledavideozapisa': res.data[i]['statuspregledavideozapisa'],
              'statusvideozapisa': res.data[i]['statusvideozapisa'],
              'idvideozapisucionica': res.data[i]['idvideozapisucionica'],
              'kratica': res.data[i]['um_kratica'],
              'trajanjevideozapisa':res.data[i]['vz_vrijemetrajanjavideozapisa'],
              'iducionicamodul': res.data[i]['iducionicamodul']
            });
          }
        } else {
          toastr.error("Nema videozapisa za ovu učionicu!");
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  dokumentiPopis(){
    let podaciZaSlanje = {
      'idkorisnik': localStorage.getItem('userId'),
      'iducionica': this.ucionicaId,
      'datum': moment(this.datum).format('YYYY-MM-DD')
    }
    //console.log(podaciZaSlanje);
    this._polaznikUcionicaService.dokumenti(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        this.sviDokumenti = [];
        if(res.data.length > 0){
          for(let i = 0; i < res.data.length; i++){
            this.sviDokumenti.push({
              'idDokumentucionica': res.data[i]['iducionicadokument'],
              'rednibroj': res.data[i]['um_redoslijedizvodenja'],
              'naziv': res.data[i]['ud_pisaninaziv'],
              'datum': moment(res.data[i]['ud_vrijemeuplouda']).format('DD.MM.YYYY.'),
              'ud_nazivtablice': res.data[i]['ud_nazivtablice'],
              'ud_nazivdokumenta': res.data[i]['ud_nazivdokumenta'],
              'datum_od': moment(res.data[i]['ud_dostupnostOd']).format('DD.MM.YYYY.'),
              'datum_do': moment(res.data[i]['ud_dostupnostDo']).format('DD.MM.YYYY.'),
              'statusvideozapisa': res.data[i]['statusvideozapisa'],
              'kratica': res.data[i]['um_kratica']
            });
          }
        } else {
          toastr.error("Nema pisanih materijala za ovu učionicu!");
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  otvoriVideo(vid){
    //console.log(vid);
    this.prikaziVideo = true;
    this.trenutniVideo = vid.idvideozapisucionica;
    this.videoNaslov = vid.naziv;
    this.Url = this._domSanitizer.bypassSecurityTrustResourceUrl("https://player.vimeo.com/video/"+vid.link);
    let podaciZaSlanje = {
      'idkorisnik': localStorage.getItem('userId'),
      'iducionica': this.ucionicaId,
      'idvideozapisucionica': vid.idvideozapisucionica,
      'iducionicamodul': vid.iducionicamodul
    }
    //console.log(podaciZaSlanje);
    this._polaznikUcionicaService.updateBrojaPregleda(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
         this.videoZapisiPopis();
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  goBackToList(){
    this._router.navigate(['/polaznik-ucionice']);
  }

  popisPredavaca(){
    this.sviPredavaci = [];
    this._ucionicaService.dohvatiPredavace({'iducionica': this.ucionicaId}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviPredavaci.push({
            'idPredavacucionica': res.data[i]['idkorisnikucionica'],
            'id': res.data[i]['idkorisnik'],
            'imeprezime': res.data[i]['ko_imeiprezime'],
            'email': res.data[i]['ko_email'],
            'telefon': res.data[i]['ko_telefon'],
            'aktivan': res.data[i]['ko_aktivan']
          });
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  dohvatiKompetencije(){
    this.sviIshodiucenja = [];
    this._ucionicaService.dohvatiKompetencije({'iducionica': this.ucionicaId}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviIshodiucenja.push({
            'idUcionicaishodiucenja': res.data[i]['ucionicaishodiucenja'],
            'rednibroj': res.data[i]['uiu_rednibroj'],
            'naziv': res.data[i]['iu_tekst'],
            'idvrstauvjerenja': res.data[i]['vrstauvjerenja_idvrstauvjerenja'],
            'vrstauvjerenja': res.data[i]['vrstauvjerenjanaziv'],
            'idpodrucjeznanja': res.data[i]['podrucjeznanja_idpodrucjeznanja'],
            'podrucjeznanja': res.data[i]['podrucjeznanjanaziv']
          })
        }
      }else{
        toastr.error("Neuspješno dohvaćanje kompetencija!");
      }
    });
  }

  dohvatiKriterije(){
    this._ucionicaService.kriterijiPopis({'iducionica': this.ucionicaId}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        if(res.data.length != 0){
          // this.postojiKriterijProlaznosti = true;
          this.sviKriterijiUcionica = res.data[0].ktk_opis;
          // this.sviKriterijiUcionica = this._domSanitizer.bypassSecurityTrustHtml(res.data[0].ktk_opis);
        } else {
          toastr.error("Trenutno ne postoje kriteriji prolaznosti!");
        }
      } else {
        toastr.error("Neuspješno dohvaćanje kriterija prolaznosti!");
        // this.postojiKriterijProlaznosti = false;
      }
    });
  }

  dohvatiModule(){
    this.sviModuli = [];
    this._polaznikUcionicaService.dohvatiModuleNew({'iducionica': this.ucionicaId}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviModuli.push({
            'naziv_modula': res.data[i]['nazivmodula'],
            'naziv_nastavnejedinice': res.data[i]['nastavnajedinica'],
            'nacinizvodenja': res.data[i]['nacinizvodenja'],
          })
        }
      }else{
        toastr.error("Neuspješno dohvaćanje modula!");
      }
    });
  }

  /* postojeci ekran moduli zamjenio je sa rasporedom koji ima sve sto je imao stari ekran moduli */
  dohvatiRaspored(){
    this.savRaspored = [];
    this._ucionicaService.dohvatiModule({'idkorisnik': localStorage.getItem('userId'), 'iducionica': this.ucionicaId}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          if(res.data[i]['um_datum']){
            this.savRaspored.push({
              'idUcionicamodul': res.data[i]['iducionicamodul'],
              'id': res.data[i]['idmodul'],
              'rednibroj': res.data[i]['um_rednibroj'],
              'brojmodula': res.data[i]['um_rednibrojmodula'],
              'redoslijedizvodenja': res.data[i]['um_redoslijedizvodenja'],
              'naziv': res.data[i]['mo_naziv'],
              'kratica': res.data[i]['um_kratica'],
              'datum': moment(res.data[i]['um_datum']).format('DD.MM.YYYY.'),
              'satiod': res.data[i]['satiodprikaz'],
              'satido': res.data[i]['satidoprikaz'],
              'datumsastanka': res.data[i]['datumsastankaprikaz'],
              'vrijemesastanka': res.data[i]['vrijemesastankaprikaz'],
              'datumivrijemesastankasql': res.data[i]['sa_vrijemesastanka'],
              'status':  res.data[i]['sa_status'],
              'dogovorisastanak': res.data[i]['status_prijedlog'],
              'idnacinpredavanja': res.data[i]['nacinpredavanja_idnacinpredavanja'],
              'idpodrucjeznanja': res.data[i]['podrucjeznanja_idpodrucjeznanja'],
              'aktivan': res.data[i]['um_aktivan']
            })
          }else{
            this.savRaspored.push({
              'idUcionicamodul': res.data[i]['iducionicamodul'],
              'id': res.data[i]['idmodul'],
              'rednibroj': res.data[i]['um_rednibroj'],
              'brojmodula': res.data[i]['um_rednibrojmodula'],
              'redoslijedizvodenja': res.data[i]['um_redoslijedizvodenja'],
              'naziv': res.data[i]['mo_naziv'],
              'kratica': res.data[i]['um_kratica'],
              'datum': null,
              'satiod': res.data[i]['satiodprikaz'],
              'satido': res.data[i]['satidoprikaz'],
              'datumsastanka': res.data[i]['datumsastankaprikaz'],
              'vrijemesastanka': res.data[i]['vrijemesastankaprikaz'],
              'datumivrijemesastankasql': res.data[i]['sa_vrijemesastanka'],
              'status':  res.data[i]['sa_status'],
              'dogovorisastanak': res.data[i]['status_prijedlog'],
              'idnacinpredavanja': res.data[i]['nacinpredavanja_idnacinpredavanja'],
              'idpodrucjeznanja': res.data[i]['podrucjeznanja_idpodrucjeznanja'],
              'aktivan': res.data[i]['um_aktivan']
            })
          }
        }
      }else{
        toastr.error("Neuspješno dohvaćanje modula!");
      }
    });
  }

  /*
  dogovoriSastanak(check_data){
    //console.log(check_data);
    if(check_data == true){

    }else if(check_data == false){

    }
  }
  */

  urediEdukacije(raspored){
    //console.log(raspored);
    let datum1;
    if(raspored.value.datum.jsdate){
      datum1 = moment(raspored.value.datum.jsdate).format('YYYY-MM-DD');
    } else {
      datum1 = moment(raspored.value.datum,'DD.MM.YYYY.').format('YYYY-MM-DD');
    }

    let objektZaSlanje = {
      idkorisnik: localStorage.getItem('userId'),
      iducionica: this.ucionicaId,
      datum: datum1,
      brojdanaranije: raspored.value.brojdanaranije,
      brojdanaizmeduedukacije: raspored.value.brojdanaizmeduedukacije
    }
    //console.log(objektZaSlanje);

    this._polaznikUcionicaService.urediEdukacije(objektZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        this.dohvatiRaspored();
      } else {
        toastr.error(res.message);
      }
    });
  }

  pripremiPodatke(raspored){
    //console.log(raspored);
    this.nastavnajedinicaEditForma = this._fb.group({
      iducionicamodul: raspored['idUcionicamodul'],
      naziv: raspored['naziv'],
      datum: raspored['datum'],
      dogovorisastanak: raspored['dogovorisastanak'],
      /* datumivrijeme: '2020-10-22T15:16' */
      datumivrijeme: raspored['datumivrijemesastankasql']
    });
    this.datumPrikaz = raspored['datum'];
  }

  uredijednuEdukaciju(raspored){
    //console.log(raspored);

    let datum1;
    if(raspored.value.datum.jsdate){
      datum1 = moment(raspored.value.datum.jsdate).format('YYYY-MM-DD');
    } else {
      datum1 = moment(raspored.value.datum,'DD.MM.YYYY.').format('YYYY-MM-DD');
    }

    let objektZaSlanje = {
      idkorisnik: localStorage.getItem('userId'),
      iducionica: this.ucionicaId,
      iducionicamodul: raspored.value.iducionicamodul,
      datum: datum1,
      dogovorisastanak: raspored.value.dogovorisastanak,
      datumsastanka: raspored.value.datumivrijeme,
    }
    //console.log(objektZaSlanje);

    this._polaznikUcionicaService.uredijednuEdukaciju(objektZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        this.dohvatiRaspored();
      } else {
        toastr.error(res.message);
      }
    });
  }

  dohvatiPrisutnost(){
    this._polaznikUcionicaService.dohvatiPrisutnostPolaznikUcionica({'idkorisnik': localStorage.getItem('userId'), 'iducionica': this.ucionicaId}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        let j = 1;
        this.svaPrisutnost = [];
        if(res.data.length > 0){
          for(let i = 0; i < res.data.length; i++){
            if(res.data[i]['um_datum']){
              this.svaPrisutnost.push({
                'id': res.data[i]['idkorisnikucionicamodul'],
                'imeiprezime': res.data[i]['ko_imeiprezime'],
                'naziv': res.data[i]['mo_naziv'],
                'kratica': res.data[i]['um_kratica'],
                'datum': moment(res.data[i]['um_datum']).format('DD.MM.YYYY.'),
                'prisutan': res.data[i]['kum_prisutan']
              })
            }else{
              this.svaPrisutnost.push({
                'id': res.data[i]['idkorisnikucionicamodul'],
                'imeiprezime': res.data[i]['ko_imeiprezime'],
                'naziv': res.data[i]['mo_naziv'],
                'kratica': res.data[i]['um_kratica'],
                'datum': null,
                'prisutan': res.data[i]['kum_prisutan']
              })
            }
            //Postotak;
            if(res.data[i]['kum_prisutan'] == 1){
                this.prisutnostDA = j++;
                this.prisutnost = (res.data.length - this.prisutnostDA) / res.data.length * 100;
                this.prisutnostUkupno = 100 - this.prisutnost;
                this.prisutnostUkupno = Math.round(this.prisutnostUkupno);
                this.prisutnostPrikaz = (Number.isNaN(this.prisutnostUkupno));
            } else {
                this.prisutnostDA = 0;
            }
            
          }
        }
      }else{
        toastr.error("Neuspješno dohvaćanje prisutnosti!");
      }
    });
  }

  dohvatiIshodeUcenja(){
    $('#ishodiNastavneJediniceTablica').DataTable().destroy();
    this._polaznikUcionicaService.dohvati_ishode_nastavnih_jedinica_za_polaznika({'iducionica': this.ucionicaId}).subscribe(res => {
      // console.log(res);
        if(res.success == true){
          if(res.data.length > 0){
            this.imaIshoda = true;
            this.ishodiUcenja = res.data;
            this.ishodiNastavneJediniceTrigger.next();
            $(document).ready(function(){
              var groupColumn = 1;
              var table = $('#ishodiNastavneJediniceTablica').DataTable({
                "columnDefs": [
                    { "visible": false, "targets": groupColumn }
                ],
                // "order": [[ groupColumn, 'asc' ]],
                "displayLength": 25,
                "drawCallback": function( settings ){
                  var api = this.api();
                  var rows = api.rows( {page:'current'} ).nodes();
                  var last = null;
        
                  api.column(groupColumn, {page:'current'} ).data().each( function ( group, i ){
                    if( last !== group ){
                      $(rows).eq( i ).before(
                        '<tr class="group"><td colspan="4">'+group+'</td></tr>'
                      );
                      last = group;
                    }
                  });
                }
              });
            });
          } else {
            this.imaIshoda = false;
            toastr.error("Nema podataka!");
          }
        } else {
          toastr.error("Neuspješno dohvaćanje ishoda učenja!");
        }
    });
  }

  prikaziTab(tabNaziv){
    //console.log(tabNaziv);
    this.tabNaziv = tabNaziv;
    switch(tabNaziv){
      case 'prikaziVideozapise':
        this.videoZapisiPopis();
      break;
      case 'prikaziDokumente':
        this.dokumentiPopis();
      break;
      case 'prikaziPredavace':
        this.popisPredavaca();
      break;
      case 'prikaziKompetencije':
        this.dohvatiKompetencije();
      break;
      case 'prikaziModule':
        this.dohvatiModule();
      break;
      case 'prikaziRaspored':
        this.dohvatiRaspored();
      break;
      case 'prisutnost':
        this.dohvatiPrisutnost();
      break;
      case 'kriterijiKompetencija':
        this.dohvatiKriterije();
      break;
      case 'ishodiUcenja':
        this.dohvatiIshodeUcenja();
    }
  }

  logoutFromClass(){
    localStorage.clear();
    sessionStorage.clear();
    this._router.navigate(['/login']);
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    $('body').removeClass('empty-layout');
    this.ishodiNastavneJediniceTrigger.unsubscribe();
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/polaznik-ucionica/polaznik-ucionica.component.ts